<template>
    <div class="success-callback">
        <sweet-modal blocking :title="$t('modal_subscriptions_planSuccessfullyPaid')" ref="success" width="600" v-on:close="closeModal()">
        <div style="width:100%">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>{{selectedPackage.packageNameDisplay}}</span>
                </div>
                <div class="text item">
                    {{$t('modal_subscriptions_description')}}: {{selectedPackage.description}}
                </div>
                <div class="text item">
                    {{$t('modal_subscriptions_usersQty')}}: {{selectedPackage.usersQty}}
                </div>
                <div class="text item">
                    {{$t('modal_subscriptions_price')}}: {{formatPrice(selectedPackage.price)}}$
                </div>
            </el-card>
        </div>
        <el-button @click="closeModal" style="margin-top:15px;" type="primary" size="small">
            {{$t('general_ok')}}
        </el-button>
    </sweet-modal>
    <sweet-modal blocking title="Payment Failed" ref="error" width="600" v-on:close="closeErrorModal()">
            <div style="width:100%">
                Sorry, but an error has occurred while processing your request. Please try again ar contact our support if the error persists.
            </div>
            <el-button @click="closeErrorModal" style="margin-top:15px;" type="primary" size="small">
                {{$t('general_ok')}}
            </el-button>
        </sweet-modal>
    </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "SuccessCallback",
    components:{
      SweetModal
    },
    data(){
      return{
        selectedPackage: {}
      }
    },
    async mounted(){
      // try {
      //   if (this.$route.query.companyId && this.$route.query.subscriptionId){
      //     await this.loadSubscriptionsList(this.$route.query.subscriptionId)
      //
      //     await this.successSession(this.$route.query.companyId, this.$route.query.subscriptionId);
      //   } else {
      //     this.$router.push( {path: '/login'})
      //   }
      // } catch (err){
      //   console.log(err)
      // }
    },
    methods:{
      successSession(companyId, subscriptionId){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/subscription/successSession?companyId=${companyId}&subscriptionId=${subscriptionId}`)
          .then(response => {
            loader.hide();
            if (response.data.subCreate.status === 'incomplete' || response.data.subCreate.status === 'cancel'){
              this.$refs.error.open()
            } else if (response.data.subCreate.status === 'active'){
              this.$refs.success.open()
            }
          })
          .catch(error => {
            loader.hide()
          });
      },
      loadSubscriptionsList(subscriptionId){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/subscription/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            loader.hide();
            this.selectedPackage = response.data.list.filter(val => val.id === Number(subscriptionId))[0]
          })
          .catch(error => {
            loader.hide()
          });
      },
      closeModal(){
        this.$router.push(`/users?companyId=${this.$route.query.companyId}&activeTab=subscriptions`);
      },
      closeErrorModal(){
        this.$router.push(`/users?companyId=${this.$route.query.companyId}&activeTab=subscriptions`);
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    }
  }
</script>

<style lang="less" scoped>
    .success-callback {
        background: #DfE8F0;
        z-index: 0;
        height: 100vh;
    }
    .content {
        display: flex;
        height: 100vh;
        padding-top: 50px;
    }
    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 0 10px 10px 10px;
    }
</style>
